import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { merchantFeesConstants } from "./merchantFees.constants";

const initialState = {
	loading: false,
	error: "",
};

export const getMerchantFeeState = state => state.merchantFees;

// prettier-ignore
export const selector = property =>
	fp.flow(getMerchantFeeState, fp.get(property));

function merchantFees(state = initialState, action) {
	switch (action.type) {
		case merchantFeesConstants.EDIT_MERCHANT_FEES_REQUEST:
			return {
				...state,
				loading: true,
			};
		case merchantFeesConstants.EDIT_MERCHANT_FEES_SUCCESS:
			return {
				...state,
				loading: false,
				error: "",
			};
		case merchantFeesConstants.EDIT_MERCHANT_FEES_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		default:
			return state;
	}
}

export default withResetState({ initialState })(merchantFees);
